import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import brandLogo from './../images/brand-logo-inverse-dark.png';

class AgradecimientoContainer extends Component {

    render = () => {
        return (
            <div className="overlay">
                <div id="content" className="container">
                    <div className="store-singup">
                        <div className="panel panel-default short">
                            <div className="panel-content">
                                <div className="panel-heading-signup text-center">
                                    <img height="64px" alt="IOS OFFICES" src={brandLogo} />
                                </div>
                                <div className="container-fluid container-padding text-center">
                                    <h2>
                                        ¡Muchas Gracias por tu Compra!
                                    </h2>
                                    <h5>
                                        Te hemos enviado un correo de confirmación con todos los detalles
                                    </h5>
                                    <p>
                                        Mientras llega el gran día, te animamos a que revises nuestra página
                                        en donde podrás reservar tus salas, ver beneficios y más.
                                    </p>
                                    <div className="form-group">
                                        <Link to="/" className="btn btn-primary btn-full-width">
                                            VISITA NUESTRA PAGINA
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('common')(AgradecimientoContainer);


// WEBPACK FOOTER //
// ./src/store/AgradecimientoContainer.js